import { rmaCartManufacturingMf, rmaCartManufacturingModelMf } from 'models/rmamanufatura/detailsRma';

export class NewRmaCartManufacturingModelMf {
    id?: any
    volumeType?: any
    identifiedTime?: any
    nfHoneywell?: any
    quantity?: any
    gbe?: any
    rmaCartManufacturing?: rmaCartManufacturingMf
}
export class NewManufacturingMf {
    rmaCartManufacturing?: rmaCartManufacturingModelMf | null

    constructor() {
        this.rmaCartManufacturing = null;
    }
}

